import { findIndex, orderBy } from 'lodash'
import dayjs from 'dayjs'

const bookingsMapper = (bookings, timeZone) => {
  const groupedBookings = []
  for (const b of bookings) {
    let yearIndex = findIndex(groupedBookings, function(o) {
      return (
        o.year ===
        dayjs(b.startTimeUTC)
          .tz(timeZone)
          .format('YYYY')
      )
    })

    // if first booking found in that year, add the year obj in
    if (yearIndex === -1) {
      groupedBookings.push({
        year: dayjs(b.startTimeUTC)
          .tz(timeZone)
          .format('YYYY'),
        months: [],
      })
      yearIndex = groupedBookings.length - 1
    }

    let monthIndex = findIndex(groupedBookings[yearIndex].months, function(i) {
      return (
        i.month ===
        dayjs(b.startTimeUTC)
          .tz(timeZone)
          .format('MMM')
      )
    })

    // if first booking found in that month, add the month obj in
    if (monthIndex === -1) {
      groupedBookings[yearIndex].months.push({
        month: dayjs(b.startTimeUTC)
          .tz(timeZone)
          .format('MMM'),
        days: [],
      })
      monthIndex = groupedBookings[yearIndex].months.length - 1
    }
    // add the booking to the appropriate year and month objects
    groupedBookings[yearIndex].months[monthIndex].days.push(b)
  }
  // create the x-series obj and tag each booked day in the month with the css class bk-booked
  // ie: this tags the blue in the month timelines
  const maxDays = 31 // max days in a month
  for (const year of groupedBookings) {
    for (const month of year.months) {
      month.xseries = Array(maxDays).fill('bkDay')
      for (const booking of month.days) {
        month.xseries[
          dayjs(booking.startTimeUTC)
            .tz(timeZone)
            .date()
        ] = 'bk-booked'
      }
    }
  }
  for (const group of groupedBookings) {
    group.months = group.months.sort(function(a, b) {
      var month = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      }
      return month[b.month] - month[a.month]
    })
  }

  return orderBy(groupedBookings, 'year', 'desc')
}

export { bookingsMapper }
